import VueI18n from 'vue-i18n'
import Vue from 'vue'
window.Vue = require('vue')

const messages = {
  en: {
    'Címlap': 'Home',
    'Rólunk': 'About',
    'Legutóbbi munkáink': 'Recent works',
    'Hogyan dolgozunk?': 'How do we do what we do?',
    'Galériák': 'Galleries',
    'Kapcsolat': 'Contact',
    'Név*': 'Name*',
    'Email*': 'Email*',
    'Tárgy*': 'Subject*',
    'Fotózás dátuma': 'Date of photo shoot',
    'Fotózás helyszíne': 'Location',
    'Egyéb': 'Other',
    'Üzenet*': 'Message*',
    'Elküldes': 'Submit',
    'Telefon': 'Phone',
    'Cím': 'Address',
    'Ajánlatkérésnél figyelj arra, hogy a lehető legtöbb információt oszd meg velünk akármilyen merész elképzelésed is van. Szeretjük a kihívásokat!': 'While enquiring, please do share as many details as possible with us no matter how far-fetched your ideas might be. We simply love challenges!',
    'Első lépésként írj nekünk, hogy megtudd van e szabad hely a naptárunkban.': 'Get in touch to find out whethere we have any available slots in our photo calendar.',
    'Fotózás': 'Photography',
    'Elkészítjük a képeket, melyeket több helyen biztonságosan tárolunk majd. Határidőn belül elvégezzük a képek válogatását és gondos utómunkáját.': 'After having taken care of the photo shoot, we safekeep the images on various types of storage media. Timely delivery of the thoroughly and professionally retouched photos is guaranteed as predefined and agreed within the contract or chosen photo bundle.',
    'Időpont egyeztetés': 'Appointment',
    'Amennyiben ajánlatunk elnyeri tetszésed, egy személyes találkozó keretében megbeszéljük a felmerülő kérdéseket, és egyeztetünk minden apró részletet.': 'Once you choose a photo bundle or accept our personalised offer, a meeting will follow in persone, where all the details, expectations and ideas can be discussed from your part and ours too.',
    'Ajánlat kérés': 'Enquiry',
    'Ajánlat kérésnél minél részletesebben írd meg nekünk, hogy mit szeretnél, mik az elképzeléseid, ötleteid, elvárásaid. 24 órán belül küldjük is az árajánlatunkat.': 'On enquiry, please do not hold back and share as many details and ideas as possible. Within 24 hours we will send you our pricelist.',
    'Képek átadása?': 'Photo delivery?',
    'A képek az előre egyeztetett határidőn belül mindenképp átadásra kerülnek privát webgalériában, így megrendelőink könnyedén megoszthatják képeiket azokkal akikkel szeretnék. A galériákat egyedi jelszóval látjuk el.': 'The final product will be delivered within the agreed time frame via online photo-gallery to easure that our customers can easily share the photos with their beloved ones.',
    'Fotó galériák': 'Photo galleries',
    'Összes': 'All',
    'Esküvő': 'Wedding',
    'Termék': 'Product',
    'Jegyes': 'Engagement',
    'Család': 'Family',
    'Kismama': 'Maternity',
    'Hogyan találtál ránk?': 'How did you find us?',
    'Portré': 'Portrait / Head-shots',
    '...ahol a pillanat emlékké változik...': '...where the moment turns into reality...',
    'Köszönjük a megkérést! Hamarosan felvesszük veled a kapcsolat.': 'Thank you for your enquiry. We will be in touch very soon.',
    ' *-al jelölt mezők kitöltése kötelező': ' All (*) marked fields are mandatory',
    'sajnáljuk, de a kért oldal nem található': 'we are sorry, but the page you requested was not found',
    'A keresett oldal nem található': 'Page not found',
    'Portfólió': 'Portfolio'

  }
}

Vue.use(VueI18n)

let language = 'hu'
if (localStorage.getItem('language')) {
  language = localStorage.getItem('language')
}
if (window.location.href.includes('/en')) {
  language = 'en'
  localStorage.setItem('language', 'en')
}

export default new VueI18n({
  locale: language, // set locale
  fallbackLocale: 'hu',
  silentTranslationWarn: true,
  messages: messages
})



// WEBPACK FOOTER //
// ./src/translate/index.js